import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { getScoringAndRank } from "../../../../../api/scoring-and-rank.ts";

export function useLeaderboard() {
  const { gameId } = useParams<{ gameId: string }>();

  if (!gameId) {
    throw new Error("gameId is required");
  }

  return useQuery({
    queryKey: ["games", gameId, "leaderboard"],
    queryFn: async () => {
      return getScoringAndRank(gameId);
    },
  });
}
